import React, { createContext, useContext, useState, useEffect } from 'react';

const VariationContext = createContext();

export const VariationProvider = ({ children }) => {
  const [variationData, setVariationData] = useState([

  ]);

  useEffect(() => {
  }, [variationData]);

  // function setImageAtIndex(index, newImage, imageType) {

  //     setVariationData((prevVariationData) => {

  //       const newVariationData = [...prevVariationData];

  //       if (newVariationData[index]) {

          // if (imageType === "Single Image") {
          //   newVariationData[index] = {
          //     ...newVariationData[index],
          //     image: newImage,
          //   };
          // }

  //         if (imageType === "Additional Image") {
  //           const currentImages = newVariationData[index].images || [];
  //           const updatedImages = Array.isArray(currentImages)
  //             ? [...currentImages, newImage]
  //             : [newImage];

  //           newVariationData[index] = {
  //             ...newVariationData[index],
  //             images: updatedImages,
  //           };
  //         }

  //       } else {
  //         console.error(`Index ${index} does not exist in newVariationData.`);
  //       }

  //       return newVariationData;
  //     });
  //   }

//   function setImageAtIndex(index, newImage, imageType) {
//     setVariationData((prevVariationData) => {
//       const newVariationData = [...prevVariationData];

//       // Ensure array has enough items
//       while (newVariationData.length <= index) {
//         newVariationData.push({}); // Push empty objects to fill gaps
//       }

//           if (imageType === "Single Image") {
//             newVariationData[index] = {
//               ...newVariationData[index],
//               image: newImage,
//             };
//           }

//       if (imageType === "Additional Image") {
//         const currentImages = newVariationData[index].images || [];
//         console.log(currentImages);
//         const updatedImages = Array.isArray(currentImages)
//           ? [...currentImages, newImage]
//           : [newImage];
//  console.log(updatedImages);
//         newVariationData[index] = {
//           ...newVariationData[index],
//           images: updatedImages,
//         };
//       }

//       return newVariationData;
//     });
//   }

function setImageAtIndex(index, newImage, imageType) {
  console.log(index, newImage, imageType, "context");

  setVariationData((prevVariationData) => {
    const newVariationData = [...prevVariationData];

    // Ensure array has enough items
    while (newVariationData.length <= index) {
      newVariationData.push({});
    }

    const imagesToAdd = Array.isArray(newImage) ? newImage : [newImage];

    if (imageType === "Single Image") {
      // Just set one image
      newVariationData[index] = {
        ...newVariationData[index],
        image: imagesToAdd[0], // Only take the first image
      };
    }

    if (imageType === "Additional Image") {
      const currentImages = newVariationData[index].images || [];
      const updatedImages = [...currentImages, ...imagesToAdd];

      newVariationData[index] = {
        ...newVariationData[index],
        images: updatedImages,
      };
    }

    return newVariationData;
  });
}


  return (
    <VariationContext.Provider
      value={{
        variationData,
        setVariationData,
        setImageAtIndex
      }}>
      {children}
    </VariationContext.Provider>
  );
};

export const useVariationContext = () => useContext(VariationContext);